import type { MaybeRef } from 'vue';
import { toValue } from 'vue';

import { getBaremetalHistory, getDataForCreateBaremetal, getServer, getServers } from './api';
import { baremetalKeys } from './keys';

export const baremetalServersQueryOptions = () => ({
  queryKey: baremetalKeys.servers(),
  queryFn: () => getServers(),
});

export const baremetalServerQueryOptions = (id: MaybeRef<number>) => ({
  queryKey: baremetalKeys.server(toValue(id)),
  queryFn: () => getServer(toValue(id)),
});

export const baremetalTaskQueryOptions = (id: MaybeRef<number>) => ({
  queryKey: baremetalKeys.baremetalTask(toValue(id)),
  queryFn: () => getServer(toValue(id)).then((data) => data.baremetal),
});

export const baremetalDataForCreateQueryOptions = () => ({
  queryKey: baremetalKeys.dataForCreate(),
  queryFn: () => getDataForCreateBaremetal(),
});

export const baremetalHistoryQueryOptions = (
  id: MaybeRef<number>,
  params: MaybeRef<{ page?: number; query?: string }>,
) => ({
  queryKey: baremetalKeys.history(id, params),
  queryFn: () => getBaremetalHistory(toValue(id), toValue(params)),
});
